"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateWidgetAlert = void 0;
var sdk_ui_1 = require("@gooddata/sdk-ui");
var utils_1 = require("../utils");
/**
 * Hook allowing to update a widget alert
 * @param config - configuration of the hook
 * @internal
 */
function useUpdateWidgetAlert(_a) {
    var widgetAlert = _a.widgetAlert, backend = _a.backend, workspace = _a.workspace, onCancel = _a.onCancel, onError = _a.onError, onLoading = _a.onLoading, onPending = _a.onPending, onSuccess = _a.onSuccess;
    var effectiveBackend = sdk_ui_1.useBackend(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspace(workspace);
    utils_1.backendInvariant(effectiveBackend, "useUpdateWidgetAlert");
    utils_1.workspaceInvariant(effectiveWorkspace, "useUpdateWidgetAlert");
    var promise = widgetAlert
        ? function () { return effectiveBackend.workspace(effectiveWorkspace).dashboards().updateWidgetAlert(widgetAlert); }
        : null;
    return sdk_ui_1.useCancelablePromise({ promise: promise, onCancel: onCancel, onError: onError, onLoading: onLoading, onPending: onPending, onSuccess: onSuccess }, [
        effectiveBackend,
        effectiveWorkspace,
        widgetAlert,
    ]);
}
exports.useUpdateWidgetAlert = useUpdateWidgetAlert;
//# sourceMappingURL=useUpdateWidgetAlert.js.map